"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DependencyLifeTime = void 0;
var DependencyLifeTime;

(function (DependencyLifeTime) {
  DependencyLifeTime[DependencyLifeTime["Transient"] = 0] = "Transient";
  DependencyLifeTime[DependencyLifeTime["Scoped"] = 1] = "Scoped";
  DependencyLifeTime[DependencyLifeTime["Singleton"] = 2] = "Singleton";
})(DependencyLifeTime = exports.DependencyLifeTime || (exports.DependencyLifeTime = {}));